import React from "react";
import { humanizeShortDateTime } from "../../lib/utilities";

const ReviewList = ({list}) => {

  return (
    <div class="comment_container">
      {list.map((item) => (
        <div class="item">
          <div class="row">
            {/* <div class="col ctr_img">
              <div class="img_container">
                <div class="img_round">
                  <img src={""} />
                </div>
              </div>
            </div> */}
            <div class="col commnet-dettail_container">
              <div class="commnet-dettail">
                <div>
                  <a>
                    <strong>
                      {item.Customer !== null ? item.Customer : "Customer"}
                    </strong>
                  </a>
                  <div></div>
                </div>
                <div class="commnet-content">{item.Content}</div>
              </div>
              <div class="comment_event">
                <span class="comment_time col">
                  <em>{humanizeShortDateTime(item.CreatedAt)}</em>
                </span>
                {/* <a class="btn_like"> Like </a>
                    <a class="btn_unlike"> Unlike </a>
                    <a class="btn_reply"> Reply </a> */}
              </div>
              <div class="comment_reply_container"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReviewList;
